"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
function isModuleLoaded(packageName) {
    var moduleLocale = store_1.default.registeredStringModules.get(packageName).locale;
    return moduleLocale
        && moduleLocale === store_1.default.currentLocale;
}
exports.default = isModuleLoaded;
